<div class="dmv-search-results inner-home">
    <div class="container">
        <div class="row no-margin">
            <!--heading section starts here-->
            <div class="col-6 col-sm-2 mt-4 ">
                <a>
                    <button class="btn btn-primary btn-back top-back-button" (click)="goBack()"><i
                            class="fa fa-chevron-left text-left"></i> Back</button>
                </a>
            </div>

            <div class="col-12 col-sm-8 mt-4">
                <div id="searchResu" class="smhd">{{title}}</div>
                <p id="addthereco">&nbsp;</p>
            </div>


            <div class="col-6 col-sm-2 icon-cart mt-4">
                <dmv-shoping-cart [donation]="dmvStoreService?.registrationsInCart?.donation"
                    [registrationsInCart]="dmvStoreService?.registrationsInCart?.dmvRegistrations"
                    [registrationsManual]="dmvStoreService?.registrationsInCart?.dmvRegistrationsManual"></dmv-shoping-cart>
            </div>

            <!--heading section ends here-->


            <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
                {{errorMessage}}
            </div>


            <form autocomplete="off" class="text-left mb-b withForIe" [formGroup]="pickupMailingForm">
                <div class="asteriskMessage">
                    *Fields marked with an asterisk are required
                </div>
                <div class="row width100">
                    <div class="col-12 col-sm-12 mb-4">
                        <label class="lblPin">Name*</label>
                        <input #registrantNameEle type="text" class="form-control" maxlength="40"
                            formControlName="registrantName"
                            [ngClass]="{ 'is-invalid': submitted && f.registrantName.errors }" name="registrantName">
                        <div class="invalid-feedback" *ngIf="f.registrantName.errors?.required">Please enter name</div>
                        <div class="invalid-feedback" *ngIf="f.registrantName.errors?.pattern">Invalid symbols found.
                            Please retry.</div>
                    </div>
                    <!-- <div class="col-12 col-sm-6 mb-4">
                 <label  class="lblPin">Last Name*</div>
                <input type="text" class="form-control" name="lname" formControlName="lname"  [ngClass]="{ 'is-invalid': submitted && f.lname.errors }">             <div class="invalid-feedback">Please enter last name</div>        
            </div>   -->


                    <div class="col-12 col-sm-6 mb-4">
                        <label class="lblPin">Address Line 1*</label>
                        <input type="text" class="form-control" name="billigAddress1" maxlength="40"
                            formControlName="billigAddress1"
                            [ngClass]="{ 'is-invalid': submitted && f.billigAddress1.errors }">
                        <div class="invalid-feedback" *ngIf="f.billigAddress1.errors?.required">Please enter address
                            line 1</div>
                        <div class="invalid-feedback" *ngIf="f.billigAddress1.errors?.pattern">Invalid symbols found.
                            Please retry.</div>
                    </div>
                    <div class="col-12 col-sm-6 mb-4">
                        <label class="lblPin">Address Line 2</label>
                        <input type="text" class="form-control" name="billigAddress2" maxlength="40"
                            formControlName="billigAddress2"
                            [ngClass]="{ 'is-invalid': submitted && f.billigAddress2.errors }">
                        <div class="invalid-feedback" *ngIf="f.billigAddress2.errors?.required">Please enter address
                            line 2</div>
                        <div class="invalid-feedback" *ngIf="f.billigAddress2.errors?.pattern">Invalid symbols found.
                            Please retry.</div>
                    </div>

                    <div class="col-12 col-lg-3 col-md-6 col-sm-6 mb-4">
                        <label class="lblPin">City*</label>
                        <input type="text" class="form-control" name="city" maxlength="25" formControlName="city"
                            [ngClass]="{ 'is-invalid': submitted && f.city.errors }">
                        <div class="invalid-feedback" *ngIf="f.city.errors?.required">Please enter city</div>
                        <div class="invalid-feedback" *ngIf="f.city.errors?.pattern">Invalid symbols found. Please
                            retry.</div>
                    </div>

                    <div class="col-12  col-lg-3 col-md-6 col-sm-6 mb-4">
                        <label class="lblPin">Country*</label>
                        <div class="select-wrapper-3 monthpicker m-auto">
                            <select class="form-control " (click)="selectChange($event)"
                                (change)="updateState(); setDownIcon($event)" (keydown)="selectChangeByKey($event)"
                                (blur)="setDownIcon($event)" formControlName="country"
                                [ngClass]="{ 'is-invalid': submitted && f.country.errors }">

                                <option [value]="''">Select One</option>
                                <option [value]="item.countryCode"
                                    *ngFor='let item of (megStoreService.configurationsData$ | async)?.megConfig?.countries'>
                                    {{item.name}}</option>

                            </select>
                            <div class="invalid-feedback">Please select country</div>
                        </div>

                    </div>

                    <div class="col-12  col-lg-3 col-md-6 col-sm-6 mb-3">

                        <label class="lblPin">State/Province/Region*</label>
                        <div class="select-wrapper-3 monthpicker m-auto">
                            <select class="form-control " (click)="selectChange($event)"
                                (keydown)="selectChangeByKey($event)" (change)="setDownIcon($event)"
                                (blur)="setDownIcon($event)" formControlName="state"
                                [ngClass]="{ 'is-invalid': submitted && f.state.errors }">

                                <option *ngIf="f.country.value ===''" [value]="''"></option>
                                <option *ngIf="f.country.value !==''" [value]="''">Select One</option>
                                <option [value]="item.regionCode" *ngFor='let item of filteredCountryRegions'>
                                    {{item.region}}</option>
                            </select>
                            <div class="invalid-feedback">Please select a state/province/region</div>
                        </div>

                    </div>
                    <div class="col-12 col-lg-3 col-md-6 col-sm-6 mb-4">
                        <label class="lblPin">zip* </label>
                        <input type="text" class="form-control" formControlName="zip" maxlength="20"
                            [ngClass]="{ 'is-invalid': submitted && f.zip.errors }">
                        <div class="invalid-feedback" *ngIf="f.zip.errors?.required">Please enter zip</div>
                        <div class="invalid-feedback" *ngIf="f.zip.errors?.pattern">Invalid symbols found. Please retry.
                        </div>
                    </div>
                    <div style="width:100%">
                        <div class="col-12 col-sm-6 mb-4" *ngIf="IsmailFee">
                            <div class="row">
                                <div class="col-6 mailfee">
                                    <span>Mail Fee:</span>
                                </div>
                                <div class="col-6 mailfee">
                                    <span>{{mailFee | number : '1.2-2' | currency | minusSignToParens}}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- 
  <div class="col-12 col-sm-6 mb-4">
                 <label  class="lblPin">Phone Number*</div>
                <input type="text" class="form-control" name="city" formControlName="phoneNumber"  [ngClass]="{ 'is-invalid': submitted && f.phoneNumber.errors }">    
                <div class="invalid-feedback">Please enter phone number </div>
            </div>    -->
                    <div style="width:100%" class="row" *ngIf="dmvStoreService?.registrationsInCart?.dmvRegistrations?.length ">
                        <div class="col-12 col-sm-12 mt-4"
                            *ngIf="updateAddressCheckBox && dmvStoreService?.agencyConfig?.agencyDmvConfig?.allowMailingToTempAddress">
                            <div class="checkbox-container  mr-15 mb-3">
                                <label>{{updateAddressCheckBox && dmvStoreService?.agencyConfig?.agencyDmvConfig?.addressUpdateCheckboxTextYes}}
                                    <input type="checkbox" (change)="updateAddressEvent($event, true)"
                                        [value]="updateAddress" formControlName="updateAddress">
                                    <span class="checkmark"
                                        [ngStyle]="f.updateAddress.value?{'background-color':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor} : {'background-color': 'transparent'}"
                                        [style.border-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor"></span>
                                </label>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12"
                            *ngIf="updateAddressCheckBox && dmvStoreService?.agencyConfig?.agencyDmvConfig?.allowMailingToTempAddress">
                            <div class="checkbox-container mr-15  mb-3">
                                <label>{{updateAddressCheckBox && dmvStoreService?.agencyConfig?.agencyDmvConfig?.addressUpdateCheckboxTextNo}}
                                    <input type="checkbox" (change)="updateAddressEvent($event, false)"
                                        [value]="!updateAddress" formControlName="notUpdateAddress">
                                    <span class="checkmark"
                                        [ngStyle]="f.notUpdateAddress.value?{'background-color':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor} : {'background-color': 'transparent'}"
                                        [style.border-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor"></span>
                                </label>
                            </div>
                        </div>
                        <div  *ngIf="permAddressUpdate" class="col-12 col-sm-12 mb-4">
                            <div class="ml-4">{{ dmvStoreService?.agencyConfig?.agencyDmvConfig?.permAddressUpdateNote}}</div>
                        </div>
                        <div  *ngIf="tempAddressChange" class="col-12 col-sm-12 mb-4">
                            <div class="ml-4">{{ dmvStoreService?.agencyConfig?.agencyDmvConfig?.tempAddressChangeNote}}</div>
                        </div>
                        <div  *ngIf="updateAddressCheckBox || permAddressUpdate || tempAddressChange" class="col-12 col-sm-12 mb-4">
                            <div class="textLink ml-4" (click)="forgetItConfirm()">{{ dmvStoreService?.agencyConfig?.agencyDmvConfig?.undoAddressChangeLinkText}}</div>
                        </div>
                    </div>
                </div>

            </form>

        </div>


        <div class="m-auto text-center">
            <a>
                <button class="btn btn-primary btn-back" (click)="goBack()"><i class="fa fa-chevron-left text-left"></i>
                    Back</button>
            </a>
            <a>
                <button class="btn btn-primary  btn-continue m-auto" (click)="continue()">Continue
                    <i class="fa fa-chevron-right text-right"></i>
                </button>
            </a>
        </div>
    </div>
</div>

<dmv-address-change-model *ngIf="openConfirmModel" (noConfirm)="noConfirm()" (yesConfirm)="yesConfirm()"
    (forgetItConfirm)="forgetItConfirm()"></dmv-address-change-model>